import { defineComponent, inject, PropType } from "vue";
import { QuantityBreak } from "@/models/QuantityBreaks";

export default defineComponent({
  props: {
    group: {
      type: Array as PropType<QuantityBreak[]>,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    productUnitType: {
      type: String,
      required: true
    }
  },
  data() {
      return{
        showPricesAsB2b:false,
        hidePrices:false,
        showQuantityBreaks: false,
        isDesktop: window.innerWidth >= 767 
      }
  },
  mounted() {
    this.showPricesAsB2b = inject<boolean>("show-prices-as-b2b", false);
    this.hidePrices = inject<boolean>("hide-prices", false);
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
    methods: {
      handleResize() {
        this.isDesktop = window.innerWidth >= 767; 
      },
      toggleQuantityBreaks() {
        this.showQuantityBreaks = !this.showQuantityBreaks;
      }
    }
});